/*
 _______________________________________________________
/ This code was generated by a tool.                    \
|                                                       |
| Changes to this file may cause incorrect behavior and |
\  will be lost if the code is regenerated.             /
 -------------------------------------------------------
       \   ,__,
        \  (oo)____
           (__)    )\
              ||--|| *
*/
enum ProductChangeAliases {
  ATTACHMENTS_LIST = 'attachments-list',
  AUTOCOMPLETE_PRODUTOS = 'autocomplete-produtos',
  BUTTON_FECHAR = 'button-fechar',
  CARD_0 = 'card-0',
  DATE_FIELD_0 = 'date-field-0',
  FETCH_LISTA_ANEXOS = 'fetch-lista-anexos',
  FIELD_ANEXOS = 'field-anexos',
  FIELD_CHANGE_DATE = 'field-change-date',
  FIELD_FILE_UPLOADER = 'field-fileUploader',
  FIELD_OBSERVACAO = 'field-observacao',
  FIELD_PRODUTO = 'field-produto',
  FIELD_PRODUTOS = 'field-produtos',
  FIELD_TEXT = 'field-text',
  FIELD_TOAST = 'field-toast',
  FILE_UPLOADER = 'file-uploader',
  FORM_PRODUCT_CHANGE = 'form-product-change',
  HPMS_CUSTOM_DIALOG = 'hpms-custom-dialog',
  INPUT_PRODUTO = 'input-produto',
  LAYOUT = 'layout',
  LAYOUT_PRODUCT_CHANGE = 'layout-product-change',
  LOADER_0 = 'loader-0',
  MAPPER_0 = 'mapper-0',
  MAPPER_1 = 'mapper-1',
  MAPPER_PRODUTOS = 'mapper-produtos',
  PANEL_1 = 'panel-1',
  PANEL_LOADER = 'panel-loader',
  PANEL_PRODUCT_CHANGE = 'panel-product-change',
  PRODUTOS_FETCH = 'produtos-fetch',
  TEXT_AREA_0 = 'text-area-0',
  TEXT_OBRIGATORIO = 'text-obrigatorio',
  TEXT_PRODUTOS = 'text-produtos',
  TEXT_PROTOCOLO = 'text-protocolo',
  TOAST_NOTIFICATION = 'toast-notification',
}
export { ProductChangeAliases };
